<template>
  <v-col data-testid="gate-feed-page-header">
    <v-row justify="space-between">
      <v-row no-gutters align="center" sm="10" md="10" lg="10">
        <v-col sm="4" md="3" lg="2">
          <h1 class="typography-heading-xlg">{{ t('global.specialtyTerms.gateFeed') }}</h1>
        </v-col>
        <v-col sm="5" md="4" lg="3">
          <warehouse-select
            data-testid="gate-feed-warehouse-select"
            :multi-select="false"
            :show-create-dock-button="false"
            :should-disable-if-no-docks="false"
            hide-icon
            class="min-width-400"
            outlined
            :clearable="false"
            :restricted-warehouse-ids="$me.warehouseAccessList"
            :auto-select-by-id="defaultWarehouseId"
            @update:model-value="persistSelectedWarehouse"
            @update:items="loadPreviousSelectedWarehouse"
            v-model="selectedWarehouse" />
        </v-col>
      </v-row>
      <v-col sm="3" md="2" lg="2" class="d-flex justify-end">
        <v-btn variant="text" data-testid="gate-feed-export-data-button">
          <v-icon size="medium" class="mr-2">mdi-arrow-down</v-icon>
          {{ t('global.buttons.exportData') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { defineComponent } from 'vue';
import { first, isObject } from 'lodash';
import useGateFeed from '@/modules/gate_feed/composables/useGateFeed';
import WarehouseSelect from '@/components/elements/selects/WarehouseSelect.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'GateFeedPageHeader',
  components: { WarehouseSelect },
  emits: ['update:warehouse-list'],
  setup(props, { emit }) {
    const gateFeedStore = useGateFeed();
    const { t } = useI18n();

    const persistSelectedWarehouse = warehouse =>
      gateFeedStore.persistSelectedWarehouse(warehouse?.id ?? null);

    const loadPreviousSelectedWarehouse = async warehouses => {
      emit('update:warehouse-list', warehouses);
      const previousData = await gateFeedStore.fetchPreviousGateFeedData();

      // When there is only one warehouse, select it by default
      if (warehouses.length === 1) {
        gateFeedStore.selectedWarehouseRef.value = first(warehouses);
      }

      if (!isObject(previousData)) {
        return;
      }

      if (previousData.selectedWarehouseId) {
        const warehouse = warehouses.find(
          warehouse => warehouse.id === previousData.selectedWarehouseId
        );
        gateFeedStore.selectedWarehouseRef.value = warehouse;
      }
    };

    return {
      persistSelectedWarehouse,
      loadPreviousSelectedWarehouse,
      selectedWarehouse: gateFeedStore.selectedWarehouseRef,
      defaultWarehouseId: gateFeedStore.defaultWarehouseIdRef,
      t
    };
  }
});
</script>
